import { useTranslation } from 'react-i18next'

import { PercentIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import CardDescription from '../CardDescription/CardDescription'
import MenuCard from '../MenuCard/MenuCard'
import ReturnsAndExchangesRatioContent from './ReturnsAndExchangesRatioContent/ReturnsAndExchangesRatioContent'
import * as Styles from './styles'

const ReturnsAndExchangesRatioCard = ({ filters, loading, data, onExport, setChartFilters, description }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle marginBottom={description ? theme.spacing.sp16 : theme.spacing.sp32}>
        <Styles.Title>
          <PercentIcon />
          {t('Distribución de cambio/devoluciones')}
        </Styles.Title>
        {onExport && <MenuCard cardName={t('Distribución de cambio/devoluciones')} onExport={onExport} />}
      </CardTitle>
      {description && <CardDescription>{description}</CardDescription>}
      <ReturnsAndExchangesRatioContent
        filters={filters}
        loading={loading}
        data={data}
        setChartFilters={setChartFilters}
      />
    </Card>
  )
}

export default ReturnsAndExchangesRatioCard
